import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _dec4, _class;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import _ from 'lodash';
import objectHash from 'object-hash';
import muiWithStyles from '@mui/styles/withStyles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';
import withWidth, { isWidthUp } from 'muiCompat/withWidth';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as tourActions from '../../../actions/tours';
import * as lessonActions from '../../../actions/lessonDetails';
import Link from '../../../components/Link';
import CustomModal from '../../../components/Modals/Modal';
import SectionItemNavigationMenu from '../../../components/SectionItemNavigationMenu/SectionItemNavigationMenu';
import HelpButton from '../../../components/Navigation/HelpButton/HelpButton';
import Tour from '../../../components/Tour';
import { isTourShown } from '../../../helpers';
import isMobileUserAgent from '../../../helpers/checkMobileUserAgent';
import LessonChangelog from '../LessonChangelog/LessonChangelog';
import CourseReviewForm from '../CourseReviewForm/CourseReviewForm';
import { messages as tourMessages } from '../Tour';
import SkholeIcon36 from '../../../components/statelessComponents/Icons/SkholeIcon36';
import messages from '../lessonDetailsMessages';
import s from './LessonHeader.scss';
import SkholeIcon19 from '../../../components/statelessComponents/Icons/SkholeIcon19';
import SkholeIcon20 from '../../../components/statelessComponents/Icons/SkholeIcon20';
import SkholeIcon18 from '../../../components/statelessComponents/Icons/SkholeIcon18';
import StarIcon from '../../../components/statelessComponents/Icons/SkholeIcon12';
import intlPropTypes from '../../../constants/intlPropTypes';
var styles = function styles(theme) {
  return {
    backToCourseBtn: _defineProperty({
      color: 'inherit',
      fontSize: '2.5rem'
    }, theme.breakpoints.down('xs'), {
      height: '24px',
      width: '24px',
      padding: 0
    })
  };
};
var LessonHeader = (_dec = withStyles(s), _dec2 = muiWithStyles(styles), _dec3 = connect(function (state) {
  return {
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    loadingChangelog: state.lessonDetails.loadingChangelog,
    course: state.courseDetails.course,
    totalTranscodingJobs: state.transcodingJobs.total,
    isTourOpen: isTourShown(state, 'lessonDetails'),
    offline: state.online.offline,
    review: state.courseReview.review
  };
}, function (dispatch) {
  return bindActionCreators({
    toggleTour: tourActions.toggleTour,
    getLessonChangelog: lessonActions.getLessonChangelog
  }, dispatch);
}), _dec4 = withWidth(), injectIntl(_class = _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(LessonHeader, _React$Component);
  var _super = _createSuper(LessonHeader);
  function LessonHeader() {
    var _this;
    _classCallCheck(this, LessonHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isMenuOpen: false,
      isChangelogShown: false,
      isCourseReviewShown: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleMenuOpen", function () {
      _this.setState({
        isMenuOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMenuClose", function () {
      _this.setState({
        isMenuOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleCourseReview", function (isCourseReviewShown) {
      _this.setState({
        isCourseReviewShown: isCourseReviewShown
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleChangelogModal", function (isChangelogShown) {
      if (isChangelogShown) {
        _this.props.getLessonChangelog(_this.props.lesson._id);
      }
      _this.setState({
        isChangelogShown: isChangelogShown
      });
      _this.handleMenuClose();
    });
    _defineProperty(_assertThisInitialized(_this), "renderBack", function () {
      var _this$props = _this.props,
        course = _this$props.course,
        formatMessage = _this$props.intl.formatMessage,
        classes = _this$props.classes;
      if (!course._id) {
        return /*#__PURE__*/_jsx(IconButton, {
          classes: {
            root: classes.backToCourseBtn
          },
          component: Link,
          to: "/"
        }, void 0, /*#__PURE__*/_jsx(ChevronLeftIcon, {
          className: s.backToCourseBtnIcon
        }));
      }
      return /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.backToTitle, {
          name: course.name
        })
      }, void 0, /*#__PURE__*/_jsx(IconButton, {
        classes: {
          root: classes.backToCourseBtn
        },
        component: Link,
        to: "/courses/".concat(course.slug)
      }, void 0, /*#__PURE__*/_jsx(ChevronLeftIcon, {
        className: s.backToCourseBtnIcon
      })));
    });
    return _this;
  }
  _createClass(LessonHeader, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (_.get(this, 'props.lesson._id') !== _.get(nextProps, 'lesson._id')) {
        this.handleMenuClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        contentTypeSwitchers = _this$props2.contentTypeSwitchers,
        lesson = _this$props2.lesson,
        course = _this$props2.course,
        switchContentType = _this$props2.switchContentType,
        totalTranscodingJobs = _this$props2.totalTranscodingJobs,
        isTourOpen = _this$props2.isTourOpen,
        toggleTour = _this$props2.toggleTour,
        formatMessage = _this$props2.intl.formatMessage,
        offline = _this$props2.offline,
        loadingChangelog = _this$props2.loadingChangelog,
        width = _this$props2.width,
        review = _this$props2.review,
        isTextContentSwitcherDisabled = _this$props2.isTextContentSwitcherDisabled;
      var _this$state = this.state,
        isMenuOpen = _this$state.isMenuOpen,
        isChangelogShown = _this$state.isChangelogShown,
        isCourseReviewShown = _this$state.isCourseReviewShown;
      var showCourseReview = isWidthUp('sm', width) && !offline && (_.get(course, 'completedLessons') >= 1 || _.get(course, 'completedQuizzes') >= 1);
      var lessonChangelogElement = function lessonChangelogElement(togglePopover) {
        return /*#__PURE__*/_jsx(ListItem, {
          "data-test-id": "0hE19XyUgAdz3YzM-AgCp",
          onClick: function onClick() {
            _this2.toggleChangelogModal(true);
            togglePopover(false);
          },
          button: true,
          dense: true
        }, void 0, /*#__PURE__*/_jsx(ListItemText, {
          primary: formatMessage(messages.changeLogMenuItem),
          classes: {
            textDense: s.groupMenuItemText,
            root: s.groupMenuItemText
          }
        }));
      };
      return /*#__PURE__*/_jsx(AppBar, {
        className: s.appBar,
        color: "default"
      }, void 0, /*#__PURE__*/_jsx(Toolbar, {
        disableGutters: !isMenuOpen,
        className: s.toolbar
      }, void 0, this.renderBack(), /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        component: "h1",
        color: "inherit",
        className: classNames(s.flex1, s.pageTitle),
        "data-test": "lesson-header",
        noWrap: true
      }, void 0, lesson.name), /*#__PURE__*/_jsx("div", {
        className: s.flex
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.flex,
        id: "content-type-switchers"
      }, void 0, showCourseReview && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "S-N-1OnQXN69ZEURE4Fid",
        variant: "text",
        onClick: function onClick() {
          return _this2.toggleCourseReview(true);
        }
      }, void 0, /*#__PURE__*/_jsx(StarIcon, {
        className: s.courseReviewIcon
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1"
      }, void 0, review ? /*#__PURE__*/React.createElement(FormattedMessage, messages.editCourseRating) : /*#__PURE__*/React.createElement(FormattedMessage, messages.leaveCourseRating))), /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.switchToVideoView)
      }, void 0, /*#__PURE__*/_jsx(Fab, {
        "data-test-id": "JAT8H2FmjXZ-zNYkV6STO",
        "aria-label": formatMessage(messages.switchToVideoView),
        className: classNames(s.contentModeButton, _defineProperty({}, s.contentModeButtonSelected, contentTypeSwitchers.video && !offline)),
        disabled: offline || !_.get(lesson, 'videos.length') && !totalTranscodingJobs && !lesson.youtubeVideoUrl,
        onClick: function onClick() {
          return switchContentType('video');
        },
        size: "small"
      }, void 0, /*#__PURE__*/_jsx(SkholeIcon18, {
        defaultColor: "#fff",
        className: s.videoMode,
        color: contentTypeSwitchers.video && !offline ? '#fff' : 'primary',
        disabled: offline || !_.get(lesson, 'videos.length') && !totalTranscodingJobs && !lesson.youtubeVideoUrl
      }))), /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.switchToAudioView)
      }, void 0, /*#__PURE__*/_jsx(Fab, {
        "data-test-id": "vJO-3eLlGGnJdZo7WRt6o",
        "aria-label": formatMessage(messages.switchToAudioView),
        className: classNames(s.contentModeButton, _defineProperty({}, s.contentModeButtonSelected, contentTypeSwitchers.audio && !offline)),
        disabled: offline || !_.get(lesson, 'audios.length'),
        onClick: function onClick() {
          return switchContentType('audio');
        },
        size: "small"
      }, void 0, /*#__PURE__*/_jsx(SkholeIcon19, {
        disabled: offline || !_.get(lesson, 'audios.length'),
        defaultColor: "#fff",
        className: s.audioMode,
        color: contentTypeSwitchers.audio && !offline ? '#fff' : 'primary'
      }))), /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.switchToTextView)
      }, void 0, /*#__PURE__*/_jsx(Fab, {
        "data-test-id": "QKRe_Cc_j3bUkrY4Pj9oo",
        "aria-label": formatMessage(messages.switchToTextView),
        className: classNames(s.contentModeButton, _defineProperty({}, s.contentModeButtonSelected, contentTypeSwitchers.text || offline)),
        onClick: function onClick() {
          return switchContentType('text');
        },
        disabled: offline || isTextContentSwitcherDisabled || !_.get(lesson, 'audios.length') && !_.get(lesson, 'videos.length') && !totalTranscodingJobs && !lesson.youtubeVideoUrl,
        size: "small"
      }, void 0, /*#__PURE__*/_jsx(SkholeIcon20, {
        defaultColor: "#fff",
        color: contentTypeSwitchers.text || offline ? '#fff' : 'primary',
        className: s.textMode,
        disabled: offline || isTextContentSwitcherDisabled || !_.get(lesson, 'audios.length') && !_.get(lesson, 'videos.length') && !totalTranscodingJobs && !lesson.youtubeVideoUrl
      })))), /*#__PURE__*/_jsx(HelpButton, {
        tour: "lessonDetails",
        className: s.helpIcon,
        lessonChangelogElement: lessonChangelogElement,
        inverted: true
      }), /*#__PURE__*/_jsx(Tour, {
        update: objectHash({
          courseId: course._id,
          contentTypeSwitchers: contentTypeSwitchers
        }),
        steps: [{
          selector: '#content-type-switchers',
          content: formatMessage(tourMessages.contentTypeSwitchers)
        }].concat(_toConsumableArray(course._id ? [{
          selector: '#lesson-navigation-button',
          content: formatMessage(tourMessages.navigationButton)
        }] : []), _toConsumableArray(contentTypeSwitchers.text && course._id && !isMobileUserAgent() ? [{
          selector: '.md-block-paragraph',
          content: formatMessage(tourMessages.highlight)
        }] : []), _toConsumableArray(contentTypeSwitchers.video && course._id ? [{
          selector: '#add-video-note-button',
          content: formatMessage(tourMessages.videoNote)
        }] : []), _toConsumableArray(course._id ? [{
          selector: isWidthUp('sm', width) ? '[data-tour="complete-lesson"]' : '[data-tour="complete-lesson-mobile"]',
          content: formatMessage(tourMessages.completeButton)
        }] : [])),
        isOpen: isTourOpen,
        onRequestClose: function onRequestClose() {
          return toggleTour('lessonDetails', false);
        },
        className: s.tour
      }), course._id && /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.course)
      }, void 0, /*#__PURE__*/React.createElement(IconButton, {
        "data-test-id": "lNOSlBzggQHH2_NX68zJB",
        "aria-label": formatMessage(messages.course),
        color: "inherit",
        onClick: isMenuOpen ? this.handleMenuClose : this.handleMenuOpen,
        ref: function ref(node) {
          _this2.menuAnchorEl = node;
        },
        classes: {
          root: s.menuButton
        },
        id: "lesson-navigation-button"
      }, /*#__PURE__*/_jsx(SkholeIcon36, {
        className: s.menuIcon
      }))))), /*#__PURE__*/_jsx(CustomModal, {
        isOpen: isChangelogShown,
        onClose: function onClose() {
          return _this2.toggleChangelogModal(false);
        },
        isLoaderOn: loadingChangelog
      }, void 0, /*#__PURE__*/_jsx(LessonChangelog, {
        onClose: function onClose() {
          return _this2.toggleChangelogModal(false);
        },
        lesson: lesson
      })), /*#__PURE__*/_jsx(CustomModal, {
        isOpen: isCourseReviewShown,
        width: "550px"
      }, void 0, /*#__PURE__*/_jsx(CourseReviewForm, {
        handleClose: function handleClose() {
          return _this2.toggleCourseReview(false);
        }
      })), this.menuAnchorEl && course._id && /*#__PURE__*/_jsx(SectionItemNavigationMenu, {
        isMenuOpen: isMenuOpen,
        menuAnchorEl: this.menuAnchorEl,
        handleMenuClose: this.handleMenuClose,
        course: course,
        currentItemId: lesson._id
      }));
    }
  }]);
  return LessonHeader;
}(React.Component)) || _class) || _class) || _class) || _class) || _class);
export { LessonHeader as default };